import { getChargebeeProductId } from './get-chargebee-product-id'
import { isProductionBilling } from './is-production-billing'

export function getCRMAddonProductId(subscription: any): string {
  if (!subscription) {
    return null
  }
  const productionSubscription = isProductionBilling(subscription)
  return subscription?.billing_period_unit === 'year'
    ? getChargebeeProductId(productionSubscription ? 'operations-yearly' : 'crm-yearly')
    : getChargebeeProductId(productionSubscription ? 'operations-monthly' : 'crm-monthly')
}
